var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "aside",
    {
      staticClass: "nk-sidebar nk-sidebar-fixed sip-sidebar",
      class: { "nk-sidebar-active": _vm.isOpen },
      attrs: {
        id: "MainSideBarRightMenu",
        "data-content": "sidebarMenu",
        "aria-label": "Primary navigation",
      },
    },
    [
      _c(
        "div",
        { staticClass: "nk-sidebar-element nk-sidebar-head sip-sidebar__head" },
        [
          _c(
            "router-link",
            {
              staticClass: "sip-brand",
              attrs: { to: "/" },
              nativeOn: {
                click: function ($event) {
                  return _vm.$emit("close-sidebar")
                },
              },
            },
            [
              _c(
                "span",
                { staticClass: "sip-brand__mark" },
                [
                  _vm.logoUrl && !_vm.logoError
                    ? _c("img", {
                        staticClass: "sip-brand__logo",
                        attrs: { src: _vm.logoUrl, alt: "" },
                        on: {
                          error: function ($event) {
                            _vm.logoError = true
                          },
                        },
                      })
                    : [_vm._v("S")],
                ],
                2
              ),
              _vm._v(" "),
              _c("span", { staticClass: "sip-brand__copy" }, [
                _c("strong", [_vm._v("Sipinor")]),
                _vm._v(" "),
                _c("small", { staticClass: "sip-brand__badge" }, [
                  _vm._v("Admin"),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "sip-sidebar__close d-xl-none",
              attrs: {
                href: "#",
                role: "button",
                "aria-controls": "MainSideBarRightMenu",
                "aria-label": "Close menu",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("close-sidebar")
                },
              },
            },
            [
              _c("admin-icon", {
                attrs: { name: "close", "aria-hidden": "true" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nk-sidebar-element sip-sidebar__body" }, [
        _c("div", { staticClass: "nk-sidebar-content" }, [
          _c(
            "nav",
            { staticClass: "nk-sidebar-menu sip-sidebar-nav" },
            _vm._l(_vm.navGroups, function (group) {
              return _c(
                "div",
                { key: group.key, staticClass: "sip-sidebar-nav__group" },
                [
                  _c("div", { staticClass: "sip-sidebar-nav__label" }, [
                    _vm._v(_vm._s(group.label)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "nk-menu sip-sidebar-nav__list" },
                    _vm._l(group.items, function (item) {
                      return _c(
                        "li",
                        { key: item.path, staticClass: "nk-menu-item" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nk-menu-link sip-sidebar-nav__item",
                              class: {
                                "router-link-active is-active":
                                  _vm.isActive(item),
                              },
                              attrs: { to: item.path, exact: item.exact },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.$emit("close-sidebar")
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "sip-sidebar-nav__icon",
                                  attrs: { "aria-hidden": "true" },
                                },
                                [
                                  _c("admin-icon", {
                                    attrs: { name: item.icon },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "sip-sidebar-nav__title" },
                                [_vm._v(_vm._s(item.title))]
                              ),
                              _vm._v(" "),
                              _vm.navMetric(item.metric)
                                ? _c(
                                    "small",
                                    {
                                      staticClass:
                                        "sip-sidebar-nav__meta sip-sidebar-nav__meta--count",
                                    },
                                    [_vm._v(_vm._s(_vm.navMetric(item.metric)))]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sip-sidebar__foot" }, [
        _vm.hasPermission("list-instance")
          ? _c("div", { staticClass: "sip-sidebar-status" }, [
              _c("div", { staticClass: "sip-sidebar-status__row" }, [
                _c("span", { staticClass: "sip-sidebar-status__live" }, [
                  _c("i", { attrs: { "aria-hidden": "true" } }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.instanceStats.running) +
                      " live\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.instanceStats.expired) + " expired"),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "sip-sidebar-user" }, [
          _c(
            "span",
            {
              staticClass: "sip-sidebar-user__avatar",
              attrs: { "aria-hidden": "true" },
            },
            [_vm._v(_vm._s(_vm.userInitials))]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "sip-sidebar-user__copy" }, [
            _c("span", { staticClass: "sip-sidebar-user__name" }, [
              _vm._v(_vm._s(_vm.userFullName)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "sip-sidebar-user__email" }, [
              _vm._v(_vm._s(_vm.userEmail)),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }